//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InfoView from './components/info-view';
import PageFeedbackView from './components/page-feedback-view';
import PageResultView from './components/page-result-view';
import DetailButtonsView from '../components/detail-buttons-view';
import PageCancelView from './components/page-cancel-view';
import PageStartView from './components/page-start-view';
import PaiDan from '../components/paiDan';
import ChargebackModalView from './components/models/chargeback-modal-view';
import PaidanChargebackModal from '../components/paidan-chargeback-modal';
import DetailTransferorderRecords from '../components/detail-transferorder-records';
import DetailShangmenRecords from '../components/detail-shangmen-records';
import DetailWeixiuRecords from '../components/detail-weixiu-records';
import DetailDepartmentFeedback from '../components/detail-department-feedback';
import ReturnVisitView from './components/return-visit-view';
import OverTimeModal from '../components/overTime-modal';
import DelayRecords from '../components/delay-Records';
import OperationLogView from './components/operation-log-view';
import WorkOrderOperationLog from './components/workOrder-operation-log';
import PageChargebackView from "./components/page-chargeback-view";

export default {
  name: 'workOrderDetail',
  components: {
    PageChargebackView,
    WorkOrderOperationLog,
    OperationLogView,
    DelayRecords,
    OverTimeModal,
    ReturnVisitView,
    DetailDepartmentFeedback,
    DetailWeixiuRecords,
    DetailShangmenRecords,
    DetailTransferorderRecords,
    PaidanChargebackModal,
    ChargebackModalView,
    PaiDan,
    PageStartView,
    PageCancelView,
    DetailButtonsView,
    PageResultView,
    PageFeedbackView,
    InfoView
  },
  data() {
    return {
      loading: false,
      id: 0,
      cancelModal: false,
      startHandleModal: false,
      chargebackModal: false,
      showPaiDanChargebackModal: false,
      showOverTimeModal: false,
      chargebackViewModal: false,
      nodes: []//二级分类
    };
  },
  computed: {
    workOrderInfo() {
      return this.$store.state.workOrder.workOrderInfo;
    }
  },
  methods: {
    /*客服反馈*/
    showFeedbackRecordModel() {
      this.$refs.feedbackViewRef.show();
    },
    /*处理结果*/
    onChangeWorkOrder() {
      this.$refs.resultViewRef.show();
    },
    /*受理*/
    editStartHandle() {
      this.startHandleModal = true;
    },

    /*延迟申请*/
    showDelay() {
      this.$refs.delayRecordsRef.show();
    },

    /*派单*/
    showPaidan() {
      this.$refs.paiDanRef.showPaiDan();
    },

    /*回访*/
    showReturnVisit() {
      this.$refs.returnVisitRef.show();
    },

    /*撤单*/
    showSaveCancelOrder() {
      this.cancelModal = true;
    },
    /*删除*/
    delWorkOrder() {
      const vm = this;
      this.$Modal.confirm({
        title: this.L('Tips'),
        content: '确认删除吗？',
        okText: this.L('Yes'),
        cancelText: this.L('No'),
        onOk: async () => {
          vm.delete(vm.id);
        }
      });
    },

    /*上门记录*/
    showShangMen() {
      this.$refs.shangMenRef.show({});
    },
    /*维修进度*/
    showWeiXiu() {
      this.$refs.weiXiuRef.show({});
    },
    /*转单*/
    transferOrder() {
      this.$refs.transferOrderRef.show({});
    },
    /*回单*/
    showReceipt() {
      this.$refs.paiDanRef.editHuiDan({});
    },
    /*退单*/
    showPaiDanChargeback() {
      // this.chargebackModal = true;
      this.showPaiDanChargebackModal = true;
    },
    /*抄送*/
    overTimeChaoSong() {
      this.showOverTimeModal = true;
    },
    delete(id) {
      const vm = this;
      this.$store.dispatch({
        type: 'workOrder/delWorkOrder',
        id: vm.id
      }).then(() => {
        this.$Notice.success({
          duration: 3,
          title: '删除成功'
        });
        vm.$router.back();
      }).finally(() => {

      });
    },
    cancelSuccess() {
      this.getWorkOrder();
    },
    getWorkOrder() {
      this.$refs.infoView.getWorkOrderById();
    },
    getNodes(data) {
      this.nodes = data;
    },
    refreshPaiDanRecords() {
      this.$refs.paiDanRef.getPaiDanList();
    },

    paiGong() {
      this.$refs.paiDanRef.onShowPaiGongModal();
    },

    /*受理+派单 操作*/
    onStartHandleAndPaiDan() {
      this.$refs.paiDanRef.showPaiDan();
    },

    // getBuildingRepairer() {
    //     this.$store.dispatch({
    //         type: 'workOrder/getBuildingRepairer',
    //         id: this.id
    //     });
    // },

    onShowPaiDanReturnOrder() {

    },
    getWorkOrderById() {
      this.loading = true;
      this.$store.dispatch({
        type: 'workOrder/getWorkOrderById',
        id: this.id
      }).then(res => {
      }).finally(() => {
        this.loading = false;
      });
    },

    onRefreshOperationLog() {
      this.$refs.operationLogRef.getOperationLogs();
    },

    handleChargeback() {
      this.chargebackViewModal = true;
    },
    onRefresh() {
      this.getWorkOrderById();
      this.onRefreshOperationLog();
    }
  },
  created() {
    this.id = parseInt(this.$route.params.id) || 0;
    // this.getBuildingRepairer();
    if (this.id > 0) {
      this.getWorkOrderById();
    }
  },
  beforeRouteUpdate(to, from, next) {
    console.log(to, from, next);
    if (to.fullPath != from.fullPath) {
      next();
      this.id = this.$route.params.id;
      this.getWorkOrderById();
      // this.getCustomerCallList();
    }
  },
  watch: {
    id() {
      if (this.id > 0) {
        // this.getBuildingRepairer();
      }
    }
  }
};
